<div class="benefits-bar oa-flex">
  <img src="https://oa-cdn.azureedge.net/oa-assets/images/yoa/7aba1310-safe-orangegrey_1032032000000000000028.png" alt="" class="benefits-icon"/>
  <div class="oa-orange benefits-cost">$4M</div>
  <div class="benefits-subtitle">
    <div>Insurance</div>
    <div>Policy</div>  
  </div>
</div>
